var Pagination = require("./Pagination").Pagination;
var Form = require("./Form").Form;
import $ from "jquery";

function showSpinner() {
    $('#nav-loader-spinner').show();
}

function hideSpinner() {
    $('#nav-loader-spinner').hide();
}

export class FilterableResult extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.props.initialState;
        this.state.currentRequest = null;
        this.state.loading = false;
    }

    componentDidMount() {

        if (this.props.baseUrl) {
            this.updateData();
        }

        window.onpopstate = function(event) {
            if (event.state) {
                location.reload();
            }
        }; 
    }

    handleUpdate()
    {
        if (this.props.onChange != null)
        {
            this.props.onChange(this.state);
        }
    }

    updateData() {
        if ( this.state.currentRequest != null )
        {
            this.state.currentRequest.abort();
        }

        showSpinner();

        var self = this;
        var data = {}

        for (var i = 0; i < this.state.filterCollection.length; i++) {
            var element = this.state.filterCollection[i];
            var elementType = typeof (element.value);
            if (elementType == "string" || elementType == "boolean" || elementType == "number" || elementType == "number") {
                data[element.name] = element.value;
            }
            else {
                data[element.name] = JSON.stringify(element.value);
            }
        }

        data["page"] = 1;
        if (this.state.resultMetadata) {
            data["page"] = this.state.resultMetadata.pageNumber;
            data["itemsPerPage"] = this.state.resultMetadata.pageSize
        }


        var stateUrl = "?" + $.param(data);

        data.altTemplate = "JSON";
        data.alias = "system";

        var path = location.pathname;
        if (this.props.baseUrl) {
            path = this.props.baseUrl;
        }

        var request = $.ajax({
            url: location.protocol + "//" + location.host + path,
            type: "GET",
            data: data,
            cache: false,
            dataType: "json",
            async: true,
            processData: true,
            success: function (data) {
                hideSpinner();
                data.currentRequest = null;
                self.setState(data, self.handleUpdate);
                history.pushState(data, null, stateUrl);
                $(document).trigger("pushstate");
            },
            error: function (data, status) {
                hideSpinner();
            }
        });

        this.setState({
            currentRequest: request
        });
    }

    handleFilterChange(formData) {
        var currentData = {};
        if (this.state.resultMetadata) {
            currentData = this.state.resultMetadata;
        }

        currentData.pageNumber = 1;

        var filterData = this.state.filterCollection;
        for (var i = 0; i < filterData.length; i++) {
            var value = formData[filterData[i].name];
            if (value != undefined)
            {
                filterData[i].value = value;
            }
        }

        this.setState({
            filterCollection: filterData,
            resultMetadata: currentData
        }, this.updateData);
    }

    handlePaginationChange(paginationData) {
        this.setState({
            resultMetadata: paginationData
        }, this.updateData);
    }

    downloadData() {
        var data = {
            altTemplate: "JSON",
            alias: "docType",
            download: "true"
        }

        for (var i = 0; i < this.state.filterCollection.length; i++) {
            var element = this.state.filterCollection[i];
            data[element.name] = element.value;
        }
    
        window.location = location.protocol + "//" + location.host + location.pathname + "?" + $.param(data);
    } 

    render() {
        var data;
        var downloadLink;
        var pagination;

        if (this.state.resultCollection != null && this.state.resultCollection.length > 0)
        {
            data = this.props.renderData(this.state.resultCollection);

            if (this.state.hidePagination != true)
            {
                pagination = <Pagination data={this.state.resultMetadata} onChange={this.handlePaginationChange.bind(this)} />;
            }

            if (this.state.hideDownloadLink != true)
            {
                downloadLink = <a href="#" onClick={this.downloadData.bind(this)}>Download Data</a>;
            }    
        }
        else {
            if (this.state.resultCollection == null) {
                data = <div className="bgc-white p-20 bd"></div>;
            }
            else {
                data = <div className="bgc-white p-20 bd">No results.</div>;
            }
            
        }

        var isLoading = null;

        if (this.state.currentRequest != null && this.props.showLoader) {
            isLoading = (<div className="loader-container"><div className="loader"></div></div>);
        }

        if (this.state.hideFilter) {
            return <div className="row">
                {isLoading}
                <div className="col-lg-12">
                    {data}
                    {pagination}
                </div>
            </div>
        }

        var filterClass = "col-lg-3 filter";
        if (this.props.filterAltClass) {
            filterClass = this.props.filterAltClass + " filter";
        }

        var mainClass = "col-lg-9";
        if (this.props.mainAltClass) {
            mainClass = this.props.mainAltClass;
        }

        return (
            <div className="row">
                <div className={filterClass}>
                    <div className="filter-header">Filter By</div>
                    <Form className="form-inline" config={this.state.filterCollection} onChange={this.handleFilterChange.bind(this)} hideButtons={true} />
                </div>
                <div className={mainClass}>
                    {isLoading}
                    {data}
                    {pagination}
                </div>
            </div>
        );
    }
} 
